<agr-dialog [data]="data" (alt)="alt()" (cancel)="cancel()" (confirm)="confirm()">
  @if (data.digitalProductSubscriptions?.length > 0) {
    <mat-list data-test="confirm-digital-products">
      <h3 mat-subheader class="text--gray" style="font-weight: normal">
        {{ 'digitalProducts' | translate }}
      </h3>
      @for (digitalProduct of data.digitalProductSubscriptions; track digitalProduct) {
        <mat-list-item data-test="confirm-digital-product-row" class="flex--justify-center">
          <mat-icon class="list-icon" matListItemIcon>store</mat-icon>
          <h3 matListItemTitle>{{ digitalProduct.skuName }}</h3>
          <p matListItemLine>
            <span>{{ getToOrderOfDigitalProductSubscription(digitalProduct) | agrNumber }} {{ digitalProduct.unitOfMeasurement }} </span>
          </p>
        </mat-list-item>
      }
    </mat-list>
  }
  @if (!isOrderValid) {
    @if (data.inactiveCropAids.length > 0) {
      <div class="notification notification-error" data-test="confirm-order-invalid-products-error">
        <mat-icon>error</mat-icon>
        {{ 'inactiveProducts' | switchTranslation }}
        <ul>
          @for (inactiveCropAid of data.inactiveCropAids; track inactiveCropAid) {
            <li data-test="confirm-order-invalid-product">{{ inactiveCropAid.name }} {{ getCropAidCodeToDisplay(inactiveCropAid.productId) }}</li>
          }
        </ul>
      </div>
    }
    @if (data.inactivePackages.length > 0) {
      <div class="notification notification-error" data-test="confirm-order-invalid-packages-error">
        <mat-icon>error</mat-icon>
        {{ 'inactivePackages' | switchTranslation }}
        <ul>
          @for (inactivePackage of data.inactivePackages; track inactivePackage) {
            <li data-test="confirm-order-invalid-package">
              {{ inactivePackage.amount | agrNumber }} {{ inactivePackage.unitOfMeasurement }} -
              {{ getCropAid(inactivePackage.productId)?.name || inactivePackage.name }}
              {{ getCropAidCodeToDisplay(inactivePackage.productId) }}
            </li>
          }
        </ul>
      </div>
    }
    @if (data.expiredOrderplanByPeriods.length > 0) {
      <div class="notification notification-error" data-test="confirm-order-expired-periods-error">
        <mat-icon>error</mat-icon>
        {{ 'expiredPeriodOrderLines' | switchTranslation }}
        <ul>
          @for (expiredOrderplanByPeriod of data.expiredOrderplanByPeriods; track expiredOrderplanByPeriod) {
            <li data-test="confirm-order-expired-period">
              {{ 'period' | translate }}
              {{ expiredOrderplanByPeriod.periodName }} -
              {{ expiredOrderplanByPeriod.cropAidName }}
            </li>
          }
        </ul>
      </div>
    }
  }
  @if (isOrderValid) {
    <mat-list data-test="confirm-order-order-lines-table">
      @for (orderplanByPeriod of groupedOrderPlansByPeriods$ | async; track orderplanByPeriod) {
        <h3 mat-subheader class="text--gray" style="font-weight: normal">
          {{ orderplanByPeriod.orderLines[0].periodName }}
          {{ 'from' | translate }}
          {{ orderplanByPeriod.orderLines[0].startDispatchFrom | agrDate: 'shortDate' }}
          {{ 'until' | translate }}
          {{ orderplanByPeriod.orderLines[0].deliverBefore | agrDate: 'shortDate' }}
        </h3>
        @if (showWarningForPeriod(orderplanByPeriod.periodId)) {
          <div class="notification notification-warning">
            <mat-icon>warning</mat-icon>
            {{ 'outsideDeliveryPeriods' | translate }}
          </div>
        }
        @for (orderLine of orderplanByPeriod.orderLines; track orderLine) {
          <mat-list-item data-test="confirm-order-order-line-row" class="flex--justify-center">
            <mat-icon class="list-icon" matListItemIcon>store</mat-icon>
            <h3 matListItemTitle>{{ orderLine.cropAidName }} {{ getCropAidCodeToDisplay(orderLine.cropAidId) }}</h3>
            <p matListItemLine>
              <span class="text--bold" style="padding-right: 12px">{{ 'orderStatus' | switchTranslation }}</span>
              <span>{{ orderLine.packageCount | agrNumber }} x {{ orderLine.packageAmount }} {{ orderLine.packageUnitOfMeasurement }}</span>
            </p>
          </mat-list-item>
        }
      }
    </mat-list>
  }
</agr-dialog>
